import { createFileRoute } from '@tanstack/react-router';

import { Button, ButtonGroup } from '@/common/components/button';
import { EmptyState, EmptyStateImage, EmptyStateMessage } from '@/shared/components/empty-states';

export const Route = createFileRoute('/memberships/setup/$member-number/complete')({
  component: CompletePage
});

function CompletePage() {
  return (
    <>
      <EmptyState>
        <EmptyStateImage src="/img/wizard_complete.svg" alt="An illustration of a trophy with a checkmark."/>
        <EmptyStateMessage>
          Congratulations! Your setup is complete. You may edit this information at any time by going to your settings.
        </EmptyStateMessage>
        <ButtonGroup vertical className="min-w-52">
          <Button to="/">OK</Button>
        </ButtonGroup>
      </EmptyState>
    </>
  );
}
